import React from 'react';
import SearchRow from './SearchRow';

const SearchesTableRows = ({
  category,
  items,
  onCheckBoxClick,
  columns,
}) => (
  items.map((item, index) => (
    <SearchRow
      key={`searches_table_row_${item.id}`}
      category={category}
      search={item}
      onCheckBoxClick={onCheckBoxClick}
      upward={index > 4}
      columns={columns}
    />
  ))
);

export default SearchesTableRows;
